export default __webpack_public_path__ + "static/media/complete.1b7f6c22.svg";